import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-set-password',
  imports: [FormsModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatIconModule, MatInputModule],
  templateUrl: './set-password.html',
  styleUrl: './set-password.scss',
})
export class SetPassword {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);

  errorMessage = '';

  submit(password: string, confirm: string): void {
    this.errorMessage = '';

    if (!password || password.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long.';
      return;
    }

    if (password !== confirm) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }

    this.auth.setPassword(password).subscribe((error) => {
      if (error) {
        this.errorMessage = error;
        this.cdr.markForCheck();
        return;
      }

      void this.router.navigateByUrl('/');
    });
  }
}
